import React from 'react'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from '@material-ui/core'
import Formsy from 'formsy-react'
import ChipInput from 'material-ui-chip-input'
import { FormattedMessage, useIntl } from 'react-intl'
import { MAX_GROUP_TITLE_TEXT_LENGTH } from 'commons/groupForm'
import { TextInput } from 'app/components/FormsyHelperComponent'
import CancelButton from 'app/components/buttons/CancelButton'
import PrimaryButton from 'app/components/buttons/PrimaryButton'
import useMobileStyle from 'app/components/mobileModal/mobileModalStyle'
import clsx from 'clsx'

export default (props) => {
  const {
      parentState,
      state,
      classes,
      toggleDialogs,
      hendleCreateGroup,
      handleAddSubgroup,
      onGroupName,
      handleDeleteSubgroup,
      CREATE_GROUP_DIALOG,
    } = props,
    { formatMessage } = useIntl()
  const mobileClasses = useMobileStyle()

  return (
    <Dialog
      fullWidth
      maxWidth="sm"
      open={parentState.isOpenCreateGroup}
      className={clsx(classes.groupDialog, mobileClasses.lessPaddingMobile)}
    >
      <DialogTitle className={classes.groupDeleteTitle}>
        <FormattedMessage id="create.group.newGroup" />
      </DialogTitle>
      <DialogContent>
        <Formsy
          onValidSubmit={hendleCreateGroup}
          className="flex flex-col justify-center w-full"
          id="createGroup"
        >
          <TextInput
            extraOnChangeFunctions={(e) => {
              onGroupName(e)
            }}
            margin="dense"
            containerClassName="mb-20"
            labelId="create.group.textField.placeholder"
            placeholderId="create.group.textField.placeholder"
            name="newGroupName"
            variant="outlined"
            rows={5}
            autoFocus
            fullWidth
            maxLength={MAX_GROUP_TITLE_TEXT_LENGTH}
          />

          <FormattedMessage id="create.group.dialogTextOne" />

          <ChipInput
            className="mt-4"
            value={state.subgroups}
            newChipKeyCodes={[13, 9]} // enter, tab
            onAdd={(subgroup) => handleAddSubgroup(subgroup)}
            onDelete={(subgroup, index) =>
              handleDeleteSubgroup(subgroup, index)
            }
            variant="outlined"
            placeholder={formatMessage({
              id: 'create.subgroups.textField.placeholder',
            })}
          />
        </Formsy>
      </DialogContent>
      <DialogActions className={classes.actionBtnsQWrapp}>
        <CancelButton
          onClick={() => {
            toggleDialogs(CREATE_GROUP_DIALOG, false)
          }}
          className={mobileClasses.modalBtn}
        />
        <PrimaryButton
          disabled={state.isDisableSubmitBtn}
          className={clsx('px-16', mobileClasses.modalBtn)}
          labelId="action.save"
          type="submit"
          autoFocus
          form="createGroup"
        />
      </DialogActions>
    </Dialog>
  )
}
